'use client';

import { trpcPricingListSkusOpen } from '@trashlab/api/src/generated/hooks';
import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import { useShoppingCart } from '@trashlab/sitesapp/src/hooks/use-shopping-cart';

export const OrderButtons = () => {
  const { website } = useTenantContext();
  const tenantId = website?.organization?.id ?? '';
  const { isLoading, addToCart } = useShoppingCart();

  const { data: skus, isLoading: isSkusLoading } =
    trpcPricingListSkusOpen.useQuery(
      {
        tenantId,
        onlineOrderEnabled: true,
        status: 'ACTIVE',
        // Exclude custom price cards (customer-specific or site-specific cards)
        defaultOnly: true,
      },
      {
        enabled: !!tenantId,
      },
    );

  const handleOrderClick = async (skuId: string, productId: string) => {
    await addToCart({ skuId, productId });
  };

  // Sort by cubic yardage (larger first)
  const sortedSkus = skus
    ? [...skus].sort((a, b) => {
        const aYardsRaw = a.product?.cubicYardage;
        const bYardsRaw = b.product?.cubicYardage;

        const aYards =
          typeof aYardsRaw === 'string'
            ? parseInt(aYardsRaw.replace(/\D/g, ''), 10) || 0
            : Number(aYardsRaw) || 0;

        const bYards =
          typeof bYardsRaw === 'string'
            ? parseInt(bYardsRaw.replace(/\D/g, ''), 10) || 0
            : Number(bYardsRaw) || 0;

        return bYards - aYards;
      })
    : [];

  if (isSkusLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white" />
      </div>
    );
  }

  if (sortedSkus.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
        {sortedSkus.map((sku) => {
          const cubicYardageRaw = sku.product?.cubicYardage;
          const cubicYardage =
            typeof cubicYardageRaw === 'string'
              ? parseInt(cubicYardageRaw.replace(/\D/g, ''), 10) || 0
              : Number(cubicYardageRaw) || 0;

          return (
            <button
              key={sku.id}
              onClick={() => {
                if (sku.product?.id) {
                  handleOrderClick(sku.id, sku.product.id);
                }
              }}
              disabled={isLoading}
              className="bg-[#E31837] hover:bg-[#C1152E] text-white font-bold py-4 px-8 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-lg shadow-lg"
            >
              {isLoading ? 'Loading...' : `Order ${cubicYardage}YD`}
            </button>
          );
        })}
      </div>
    </>
  );
};
